// extracted by mini-css-extract-plugin
module.exports = {"color-danger":"style_color-danger__HCjq4","background-color-secondary":"style_background-color-secondary__4XhFo","container":"style_container__VAWyL","box":"style_box__bWndn"};